import React from 'react'
import { history } from 'store/store'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import { Button } from 'components/buttons'

export const BackButton = ({ metadata, hideGoBack, localize }) => {
  const { backUrl } = metadata

  const onGoBack = React.useCallback(() => {
    if (backUrl) {
      history.push(backUrl)
    } else {
      history.goBack()
    }
  }, [backUrl])

  return hideGoBack === true ?
  null :
  <Button variant='text' className='go-back-button' marginRight={10} minWidth='inherit' width={25} title={localize('common.goBack')} onClick={onGoBack}><ChevronLeftIcon /></Button>
}
